<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un país</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} todos los paieses</option>
        <option v-for="Pais in PaisesLocal" v-bind:key="Pais.PaisId" v-bind:value="Pais.PaisId">{{Pais.Nombre}}</option>        
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'  

  export default {
    data() {
      return {
        enumeraciones,
        PaisesLocal:[],        
        idDelModelo: null
      }
    },
    computed:{
      PaisId(){return this.$store.state.PJ_Catalogos_037PaisId}
    },
    mounted(){      
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const parametros = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
        this.$store.dispatch("A_PJ_Catalogo_Establecer037Pais", parametros);
    },    
    created(){
      this.cargaCatalogoDePaises();
    },
    methods:{
      cargaCatalogoDePaises(){
        let peticion = {
          EsPrueba: this.enumeraciones.EsPrueba          
        }                  
        axios.post(api.conexion + api.PJ.catalogos.C037Paises,peticion)
        .then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.error(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {                                     
              this.PaisesLocal = respuesta.data.Paises;
            }
          })
          .catch(excepcion => 
          {
            console.error(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const parametros =
        {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_PJ_Catalogo_Establecer037Pais",parametros);
        this.$emit("valorParaElPadre",evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      },
    },
    props: {
      parametros: Object,
      valorDefinido:Number,   
      idDelInput: String, 
      local: null,
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/037Paises.vue